import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../../services/api/endpoint";
import { Permission } from "../../../../utils/enums";
import GridPanel from "../../../global/gridpanel";
import { checkBoxCell, customCell } from "../../../global/gridpanel/customCells/gridCells";
import { IRoutedTabProps } from "../../../global/routertabpanel";
import TeamEditor from "./editor";

const Teams: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.TeamsList}
			endpoint={Endpoint.Teams}
			addScreen={TeamEditor}
			editScreen={TeamEditor}
			showDelete
			addPermission={Permission.TeamsAdd}
			editPermission={Permission.TeamsUpdate}
			deletePermission={Permission.TeamsDelete}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="lead.fullName" title={t("lead")} />
			<GridColumn field="colleague.fullName" title={t("colleague")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell(false))} />
		</GridPanel>
	);
};

export default Teams;